import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  background-color: black;
  width: 100%;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  position: sticky;
  top: 0;
  left: 0;
`;

export { Container };
